/* eslint-disable no-undef */
let map;
let infowindow;

// eslint-disable-next-line prefer-const
let markers = [];

/**
 * An location object
 * @typedef {{lat: number, lng: number}} Location
 */

/**
 * An store object
 * @typedef {{title: string, adress: string, zip: string, city: string, phone: string, lat: number, lng: number, distance: number}} Store
 */

/**
 * Init google maps
 */
async function initMap() {
  const input = document.getElementById("map-searchbox");
  const autocomplete = new google.maps.places.Autocomplete(input);
  // Request needed libraries.
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    "marker"
  );

  map = new Map(document.getElementById("map"), {
    center: { lat: 52.519325, lng: 13.392709 },
    zoom: 4,
    mapId: "2463522056edeba8",
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: true,
    scaleControl: false,
    streetViewControl: true,
    rotateControl: false,
    fullscreenControl: true,
  });

  infowindow = new InfoWindow();

  // eslint-disable-next-line no-unused-vars
  const pinBackground = new PinElement({
    background: "#FBBC04",
  });

  const locationButton = document.getElementById("mylocation");
  locationButton.addEventListener("click", () => {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          map.setCenter(pos);
          map.setZoom(8);
        },
        () => {
          handleLocationError(true, infoWindow, map.getCenter());
        }
      );
    } else {
      // Browser doesn't support Geolocation
      handleLocationError(false, infoWindow, map.getCenter());
    }
  });

  const addMarker = (place, index) => {
    const location = {
      lat: place.lat,
      lng: place.lng,
    };

    const marker = new AdvancedMarkerElement({
      map,
      position: location,
      title: place.title,
    });

    const content = document.createElement("div");
    content.classList.add(
      "space-y-8",
      "text-secondary-14-125-600",
      "mb-gutter"
    );

    if (place.title) {
      const header = document.createElement("h3");
      header.classList.add("font-bold");
      header.innerHTML = place.title;
      content.appendChild(header);
    }

    if (place.address && place.zip && place.city) {
      const adress = document.createElement("p");
      adress.classList.add("adress");
      adress.innerHTML = `${place.address}<br />${place.zip} ${place.city}`;
      content.appendChild(adress);
    }

    if (place.phone) {
      const phone = document.createElement("p");
      phone.classList.add("phone");
      phone.innerHTML = place.phone;
      content.appendChild(phone);
    }

    if (place.email) {
      const email = document.createElement("p");
      email.classList.add("email");
      email.innerHTML = place.email;
      content.appendChild(email);
    }

    marker.addListener("click", function () {
      infowindow.setContent(content);
      infowindow.open(map, marker);
      sortStores(location.lat, location.lng);
    });

    markers.push(marker);

    createStore(place, index);
  };

  storeLocations.forEach(
    (place, index) => place.lat && place.lng && addMarker(place, index, false)
  );

  const renderer = {
    render: ({ count, position }) => {
      const svg = window.btoa(`
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <circle cx="24" cy="24" r="24" fill="#FF9826" fill-opacity=".35" />
        <circle cx="24" cy="24" r="23.5" stroke="#000" stroke-opacity=".15" />
        <rect x="12" y="12" width="24" height="24" fill="#FF9826" rx="12" />
      </svg>`);
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(48, 48),
        },
        label: {
          text: String(count),
          color: "rgba(0,0,0,1)",
          fontSize: "10px",
          fontWeight: "600",
        },
        title: `Cluster of ${count} markers`,
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  };

  // eslint-disable-next-line no-new
  new markerClusterer.MarkerClusterer({ markers, map, renderer });

  autocomplete.bindTo("bounds", map);
  autocomplete.setFields(["address_components", "geometry", "name"]);

  // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
  autocomplete.addListener("place_changed", function () {
    const place = autocomplete.getPlace();

    if (!place.geometry) {
      // eslint-disable-next-line no-console
      console.log("Returned place contains no geometry");
      return;
    }
    const bounds = new google.maps.LatLngBounds();

    if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    // sort list
    sortStores(lat, lng);

    // fitBounds to 3 closest markers to location
    const closest = findClosestLocations(place.geometry.location, 3);

    for (let i = 0; i < closest.length; i++) {
      bounds.extend(closest[i].position);
    }
    map.fitBounds(bounds);
  });

  window.addEventListener("geoLocationUpdated", handleGeoLocation);
}

/**
 *
 * @param {Location} from
 * @param {number} numberOfResults
 * @returns Location[]
 */
function findClosestLocations(from, numberOfResults = 3) {
  let closest;
  for (let i = 0; i < markers.length; i++) {
    markers[i].distance = google.maps.geometry.spherical.computeDistanceBetween(
      from,
      markers[i].position
    );
    closest.push(markers[i]);
  }
  closest.sort(
    (locationA, locationB) => locationA.distance - locationB.distance
  );
  return closest.splice(0, numberOfResults);
}

/**
 * Appends store HTML to #stores
 * @param {Store} place - Store object
 */
function createStore(place, index) {
  const store = document.createElement("div");
  store.dataset.lat = place.lat;
  store.dataset.lng = place.lng;
  store.dataset.index = index;
  store.classList.add("store");

  const header = document.createElement("div");
  header.classList.add(
    "md:border-t",
    "md:border-lightgrey",
    "text-small-bold",
    "md:pt-8",
    "max-md:col-start-1",
    "max-md:col-end-6"
  );
  header.innerHTML = place.title;

  const content = document.createElement("div");
  content.classList.add(
    "gap-6",
    "flex",
    "flex-col",
    "max-md:col-start-7",
    "max-md:col-end-12"
  );

  const divLeft = document.createElement("div");
  divLeft.classList.add("col-span-4");
  divLeft.innerHTML = `
    <p>${place.address}</p>
    <p>${place.zip} ${place.city}</p>
    <p>${place.country}</p>
  `;
  content.appendChild(divLeft);

  const divRight = document.createElement("div");
  divRight.classList.add("col-span-4");
  content.appendChild(divRight);

  const contact = document.createElement("div");
  contact.classList.add("contact-info");
  contact.innerHTML = `
    <div class="mb-8 max-md:mt-12">
      <p>${strings.contact}</p>
    </div>
    ${place.email ? `<p>${place.email}</p>` : ""}
    ${place.phone ? `<p>${place.phone}</p>` : ""}
  `;
  divRight.appendChild(contact);

  store.appendChild(header);
  store.appendChild(content);
  stores.appendChild(store);
}

function fitBoundsToMarkers(markerList) {
  const bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < markerList.length; i++) {
    bounds.extend(markerList[i].position);
  }
  map.fitBounds(bounds);
}

function handleGeoLocation(event) {
  const geoLocation = event.detail.message;
  if (geoLocation && geoLocation.coords) {
    const location = {
      lat: geoLocation.coords.latitude,
      lng: geoLocation.coords.longitude,
    };
    const closestLocations = findClosestLocations(location, 3);
    fitBoundsToMarkers(closestLocations);
    sortStores(location.lat, location.lng);
  }
}

const getDistance = (x1, x2, y1, y2) => {
  const positionY = x2 - x1;
  const positionX = y2 - y1;

  return Math.sqrt(positionX * positionX + positionY * positionY);
};

// Function to sort Data
function sortStores(lat, lng) {
  // add distance from marker to location
  const stores = document.querySelectorAll(".store");
  stores.forEach((store) => {
    store.dataset.distance = getDistance(
      store.dataset.lat,
      lat,
      store.dataset.lng,
      lng
    );
  });

  const subjectsArray = Array.from(stores);

  const sorted = subjectsArray.sort((divA, divB) => {
    const distanceA = parseFloat(divA.dataset.distance);
    const distanceB = parseFloat(divB.dataset.distance);
    return distanceA - distanceB;
  });

  stores.innerHTML = "";
  sorted.forEach((store) =>
    document.querySelector("#stores").appendChild(store)
  );
  return sorted;
}

window.initMap = initMap;
